import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISetClipTitleV1Response } from './set-clip-title-v1-response';
import { setClipTitleV1ResponseSchema } from './set-clip-title-v1-response';

export async function setClipTitleV1Api(
  clipId: number,
  title: string,
): Promise<IValidatedResponse<ISetClipTitleV1Response>> {
  return postRequest<ISetClipTitleV1Response>({
    path: `/sys/clips/${clipId}/title/v1`,
    body: { title },
    schema: setClipTitleV1ResponseSchema,
  });
}
